import React from 'react';
import { observer } from 'mobx-react-lite';
import { SectionTab } from 'polotno/side-panel';
import { Images } from './images';
import { Button } from '@blueprintjs/core';

import * as api from '../api';

const ImagesPanel = observer(({ store }) => {
  const [refreshToken, setRefreshToken] = React.useState(0);
  return (
    <div style={{ height: '100%', overflow: 'auto', paddingRight: '3px' }}>
      <Images
        store={store}
        api={`${
          api.API
        }/GetFavouriteSwatches?memberId=${api.getMemberId()}&token=${refreshToken}`}
        getCredit={(item) => {
          return (
            <div>
              <Button
                icon="trash"
                onClick={async (e) => {
                  e.stopPropagation();
                  await api.unFavouriteSwatch({ productKey: item.productKey });
                  setRefreshToken(refreshToken + 1);
                }}
              ></Button>
            </div>
          );
        }}
      />
    </div>
  );
});

// define the new custom section
export const ImagesSection = {
  name: 'images',
  Tab: (props) => (
    <SectionTab name="Saved Images" {...props}>
      <img
        src={process.env.PUBLIC_URL + '/icons/saved-images.svg'}
        alt="Size"
        style={{ width: '25px' }}
      />
    </SectionTab>
  ),
  // we need observer to update component automatically on any store changes
  Panel: ImagesPanel,
};
